<template>
	<div class="bingliComp">
		<div style="line-height: 200px;font-size: 14px;text-align: center;">开发中</div>
	</div>
</template>
<script>
	export default {
		data(){
			return{
				
			}
		},
		computed:{
			userInfo(){
				return this.$store.state.yiliaoxin.userInfo
			},
			curPetInfo(){
				let obj = this.$store.getters["yiliaoxin/curPetInfo"]
				return obj
			},
		},
		mounted(){
			
		},
		methods: {
			
		},
	}
</script>
<style scoped lang="scss">
	.bingliComp{
		
	}
</style>
